export default {"src":"/_next/static/media/gold-vault.3f84e560.svg","height":40,"width":42,"blurWidth":0,"blurHeight":0};